import React from "react";

/// One line of a "here is what this will do" dialog: a tinted icon, the count,
/// what it counts, and the consequence beneath. Mirrors the publish-validation
/// sections so a destructive review and a blocked publish read the same way.
export const ImpactRow: React.FC<{
  icon: React.ReactNode;
  count?: number;
  label: string;
  hint?: string;
  tone?: "default" | "warning";
  /// What the row is about, listed under it — e.g. the tables you can rescue.
  children?: React.ReactNode;
}> = ({ icon, count, label, hint, tone = "default", children }) => (
  <div className="flex gap-2">
    <span
      className={`flex size-5 shrink-0 items-center justify-center ${
        tone === "warning" ? "text-warning" : "text-fg-muted"
      }`}
    >
      {icon}
    </span>
    <span className="flex min-w-0 flex-1 flex-col gap-0.5">
      <span className="text-fg-medium">
        {count !== undefined && (
          <span
            className="font-mono"
            style={{ fontVariantNumeric: "tabular-nums" }}
          >
            {count}{" "}
          </span>
        )}
        {label}
      </span>
      {hint && <span className="text-fg-muted-regular-small">{hint}</span>}
      {children}
    </span>
  </div>
);

/// `1 space` / `2 spaces`, for the labels above.
export const plural = (n: number, word: string, suffix = "s") =>
  n === 1 ? word : `${word}${suffix}`;
